'use strict';

var angular = require('angular');
var dependencies = ['restangular', 'AVRO.Common.Configuration'];
module.exports = angular.module('AVRO.DataExtract.Scheduled', dependencies).controller('DataExtractScheduledController', require('./controllers/DataExtractScheduledController')).directive('rmDataExtractScheduledPanel', require('./directives/DataExtractScheduledPanelDirective'));